import React from "react";
import { delGallerie } from "../actions/gallerie";
import { connect } from "react-redux";
import { getDomain, tempAlWait } from "../helpers";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical, faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";

class AdminItemGallerie extends React.Component {
    state = {
        optActive: false
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.redDelGall != this.props.redDelGall) {
            this.props.changeAlert(this.props.redDelGall.alert);

            if (this.props.redDelGall.isNext) {
                this.props.refreshList(true);
            }
        }
    }

    handleDelete(id) {
        if (window.confirm("Souhaitez-vous réellement supprimer cette image de la galerie ?")) {
            this.props.changeAlert(tempAlWait());
            this.props.delGallerie({gallId: id});
        }
    }

    render() {
        return <li className="admin__item admin__item--gall">
            {/** Id **/}
            <span className="admin__item__id">{this.props.data.id}</span>

            {/** Image **/}
            <div className="admin__item__blogimg">
                <img src={`${getDomain()}image/gallerie/${this.props.data.img}`} alt={this.props.data.desc} className="admin__item__img" />
            </div>

            {/** Description **/}
            <span className="admin__item__desc">{this.props.data.desc}</span>

            {/** Options **/}
            <div className={`admin__item__opts ${this.state.optActive && "admin__item__opts--active"}`}>
                {/** Voir **/}
                <a
                    title="Voir l'image"
                    aria-label="Voir l'image"
                    className="admin__item__optbtn"
                    href={`${getDomain()}image/gallerie/${this.props.data.img}`}
                    target="_blank"
                >
                    <FontAwesomeIcon icon={faEye} />
                </a>

                {/** Modifier **/}
                <Link
                    title="Modifier l'image"
                    aria-label="Modifier l'image"
                    className="admin__item__optbtn"
                    to={`/admin/galerie/edit/${this.props.data.id}`}
                >
                    <FontAwesomeIcon icon={faPen} />
                </Link>

                {/** Supprimer **/}
                <button
                    title="Supprimer l'image"
                    aria-label="Supprimer l'image"
                    className="admin__item__optbtn admin__item__optbtn--del"
                    onClick={() => this.handleDelete(this.props.data.id)}
                >
                    <FontAwesomeIcon icon={faTrashCan} />
                </button>
            </div>

            {/** Options bouton **/}
            <button
                title={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                aria-label={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                className="admin__item__btnopt"
                onClick={() => this.setState({optActive: !this.state.optActive})}
            >
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </button>
        </li>
    }
}

const mapStateToProps = state => {
    return {
        redDelGall: state.redDelGall
    }
}

const mapDispatchToProps = {
    delGallerie
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminItemGallerie);